"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemeContext = exports.ThemeProvider = void 0;
var react_1 = __importDefault(require("react"));
var colors_1 = require("../config/colors");
var ThemeContext = react_1.default.createContext(colors_1.THEME.light);
exports.ThemeContext = ThemeContext;
var ThemeProvider = function (props) {
    if (!props.children) {
        return null;
    }
    return react_1.default.createElement(ThemeContext.Provider, { value: props.theme }, props.children);
};
exports.ThemeProvider = ThemeProvider;
exports.default = ThemeProvider;
